import { Quote, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const COCKPIT_IMG =
  "https://images.unsplash.com/photo-1684011491364-65ec75d0f36d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOUp8MHwxfHNlYXJjaHszfHxyYWNpbmclMjBzaW11bGF0b3IlMjBzdGVlcmluZyUyMHdoZWVsJTIwZGFya3xlbnwwfHx8fDE3OTA5NjIyNzV8MA&ixlib=rb-4.1.0&q=78&w=1200";

export const SocialProof = ({ onNavigate }) => (
  <section id="solutions" className="relative py-20 lg:py-28" data-testid="solutions-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal>
        <div className="relative clip-corner border border-line overflow-hidden group">
          <img
            src={COCKPIT_IMG}
            alt="Racer strapped into a professional simulator cockpit bathed in electric blue light"
            loading="lazy"
            className="w-full h-[380px] sm:h-[440px] lg:h-[520px] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-ink/20" />
          <div className="absolute bottom-5 left-5 flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-electric animate-pulse-glow" />
            <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-electric">
              Live on the expo floor
            </span>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-electric">Why Impact Activations</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-slate-50 mt-4 leading-[1.02]">
            Real Racing. Real People. <span className="text-electric">Real Impact.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <blockquote
            className="relative border-l-2 border-electric pl-6 mt-9"
            data-testid="social-proof-quote"
          >
            <Quote className="h-7 w-7 text-electric/60 mb-4" strokeWidth={1.5} />
            <p className="font-display text-xl sm:text-2xl font-semibold text-slate-100 leading-snug">
              "The most engaging activation at our show. People couldn't get enough."
            </p>
            <footer className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
              — Event Marketing Director, <span className="text-slate-200">Fortune 500 Brand</span>
            </footer>
          </blockquote>
        </Reveal>
        <Reveal delay={0.24}>
          <a
            href="#simulators"
            onClick={(e) => {
              e.preventDefault();
              onNavigate("#simulators");
            }}
            data-testid="social-proof-learn-more"
            className="group inline-flex items-center gap-2 mt-9 font-display font-bold text-sm uppercase tracking-[0.15em] text-electric hover:text-electric-hover transition-colors"
          >
            Learn More
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
